import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'

const result = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.RESULTS_BASE_URL
    return AxiosInstance
  },
  getAllResults(
    offset,
    limit,
    status,
    timestamp,
    exported,
    codeOsLis,
    codeOsAlvaro,
    patientName,
    dateType,
    integrated,
    outputResult
  ) {
    return this.axios().get('/', {
      params: {
        limit: limit,
        offset: offset * limit,
        status: status,
        exported: exported,
        codeOsLis: codeOsLis,
        q: codeOsAlvaro,
        patientName: patientName,
        dateType: dateType,
        integrated: integrated,
        startDate: timestamp.hasTime ? null : timestamp.start,
        endDate: timestamp.hasTime ? null : timestamp.end,
        startDateTime: timestamp.hasTime ? timestamp.start : null,
        endDateTime: timestamp.hasTime ? timestamp.end : null,
        output: outputResult || null
      }
    })
  },
  getTotalResults(limit, status, timestamp, exported, q, integrated) {
    return this.axios().get('/results-count', {
      params: {
        limit: limit,
        status: status,
        exported: exported,
        q: q,
        integrated: integrated,
        startDate: timestamp.hasTime ? null : timestamp.start,
        endDate: timestamp.hasTime ? null : timestamp.end,
        startDateTime: timestamp.hasTime ? timestamp.start : null,
        endDateTime: timestamp.hasTime ? timestamp.end : null
      }
    })
  },
  getResultsStatistics(offset, limit, startDate, endDate, exported, integrated) {
    return this.axios().get('/statistics', {
      params: {
        limit: limit,
        offset: offset * limit,
        startDate: startDate,
        endDate: endDate,
        exported: exported,
        integrated: integrated
      }
    })
  },
  exportResultById(ids, outputResult) {
    return this.axios().post(
      '/export',
      {
        examLISTagEvenIfEmpty: getCookie('toggleAol').feature.examLISTagEvenIfEmpty,
        withResponsible: getCookie('toggleAol').feature.responsibleSignature,
        solsIds: ids,
        bloodCount: getCookie('toggleAol').feature.bloodCount,
        collectDate: getCookie('toggleAol').feature.collectDate,
        output: outputResult,
        exameCNESResponsavelLiberacao: getCookie('resultCnes') ? getCookie('resultCnes') : false,
      },
      {
        responseType: 'arraybuffer'
      }
    )
  },
  exportResultByFilter(timestamp, exported, dateType, integrated, outputResult) {
    return this.axios().post(
      '/export-by-filter',
      {
        exported: exported,
        integrated: integrated,
        dateType: dateType,
        examLISTagEvenIfEmpty: getCookie('toggleAol').feature.examLISTagEvenIfEmpty,
        withResponsible: getCookie('toggleAol').feature.responsibleSignature,
        bloodCount: getCookie('toggleAol').feature.bloodCount,
        collectDate: getCookie('toggleAol').feature.collectDate,
        exameCNESResponsavelLiberacao: getCookie('resultCnes') ? getCookie('resultCnes') : false,
        startDate: timestamp.hasTime ? null : timestamp.start,
        endDate: timestamp.hasTime ? null : timestamp.end,
        startDateTime: timestamp.hasTime ? timestamp.start : null,
        endDateTime: timestamp.hasTime ? timestamp.end : null,
        output: outputResult || null
      },
      {
        responseType: 'arraybuffer'
      }
    )
  }
}

export default result
